import React from 'react';
import cx from 'classnames';

import './style.css';

/**
 * This component is a helper for other components when rendering a scroll bar.
 */
interface IProps {
  className?: string;
  children: React.ReactNode;
  maxHeight?: number | string;
  containerRef?: React.RefObject<HTMLDivElement>;
  style?: object;
}

/**
 * Content that wishes to have the height of the container determined by the content, needs to pass
 * a maxHeight prop. For content whos height does not care about how much content is inside, do not provide a maxHeight
 */
export const Scroll: React.FC<IProps> = ({
  className,
  containerRef,
  children,
  maxHeight,
  style,
}) => {
  const combinedClass = cx({
    'panda-scroll-container': true,
    [className || '']: !!className,
  });

  return (
    <div className={combinedClass} style={style}>
      <div
        className="panda-scroll"
        ref={containerRef}
        style={{
          maxHeight: !!maxHeight
            ? typeof maxHeight === 'number'
              ? `${maxHeight}px`
              : maxHeight
            : '',
        }}
      >
        {children}
      </div>
    </div>
  );
};
